import "./TextInput.scss";
import {InputHTMLAttributes} from "react";
import classNames from "classnames";

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {}

export function TextInput(props: TextInputProps) {
    return <input {...props} className={classNames("TextInput", props.className)}/>
}